// Upper-case the first character of a string, leaving the rest untouched.
// Used for tier / status labels ("premium" -> "Premium").
export function capitalize(str) {
  if (!str) {
    return "";
  }
  return str.charAt(0).toUpperCase() + str.slice(1);
}
